import { useContext } from "react";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { EXPECTED_ACTION_ERROR } from "containers/DynamicForm/useButtonAction";

export const useValidateForm = () => {
  const { form } = useContext(DynamicFormContext);

  const validateFormCommand = async () => {
    const isFormValid = form.validateAllFields();

    if (!isFormValid) {
      throw Error(EXPECTED_ACTION_ERROR);
    }
  };

  return validateFormCommand;
};
